<template>
  <div class="footer-search">
    <div class="img-wrapper">
      <img
        src="https://imgheybox.max-c.com/oa/2024/11/18/17b3fb9a2b560bfcb9d33dc0857b8f07.png"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.footer-search {
  padding: 20px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .img-wrapper {
    height: 18px;
    img {
      height: 18px;
    }
  }
}
</style>
